import React from "react";

type ModalConfirmationDeleteProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
};

const ModalConfirmationDelete: React.FC<ModalConfirmationDeleteProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
}) => {
  if (!isOpen) return null; // Jangan tampilkan modal jika tidak dalam keadaan open

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50"
      onClick={onClose}
    >
      <div
        className="bg-white p-6 rounded-lg max-w-sm w-full"
        onClick={(e) => e.stopPropagation()} // Agar klik di dalam modal tidak menutup modal
      >
        <h2 className="text-base font-semibold text-center mb-6">
          {title ?? "Apakah Anda Yakin Akan Membatalkan Transaksi?"}
        </h2>
        <div className="flex justify-center space-x-4">
          <button
            className="bg-gray-300 text-black py-2 px-6 rounded-lg hover:bg-gray-400 transition"
            onClick={onClose}
          >
            No
          </button>
          <button
            className="bg-red-500 text-white py-2 px-6 rounded-lg hover:bg-red-600 transition"
            onClick={onConfirm}
          >
            Yes
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModalConfirmationDelete;
